enum KeyCode {
    ALT = 18,
    At = 50,
    BACKSPACE = 8,
    CAPS_LOCK = 20,
    COMMA = 188,
    CONTROL = 17,
    DELETE = 46,
    DOWN = 40,
    END = 35,
    ENTER = 13,
    ESCAPE = 27,
    HOME = 36,
    INSERT = 45,
    LEFT = 37,
    PAGE_DOWN = 34,
    PAGE_UP = 33,
    PERIOD = 190,
    RIGHT = 39,
    SEMI_COLON = 186,
    FIREFOX_SEMI_COLON = 59,
    SHIFT = 16,
    SPACE = 32,
    TAB = 9,
    UP = 38,
    F1 = 112,
    F2 = 113,
    F6 = 117,
    F10 = 121,
    IME_INPUT = 229,
    M = 77,
    N = 78,
    P = 80,
    Q = 81,
    S = 83,
    E = 69,
    A = 65,
    B = 66,
    C = 67,
    D = 68,
    G = 71,
    H = 72,
    I = 73,
    J = 74,
    K = 75,
    L = 76,
    O = 79,
    T = 84,
    U = 85,
    QUESTION_MARK = 191,
    CONTEXT_MENU = 93,
}

export default KeyCode;
